import React, { useRef } from 'react';
import { Button as UiButton } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

interface Props {
  htmlId?: string;
  className?: string;
  icon?: IconProp;
  iconRight?: IconProp;
  text: string;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  onClick?: () => void;
  title?: string;
  style?: React.CSSProperties;
}

const LastValueButton: React.FC<Props> = ({
  htmlId,
  className,
  icon,
  iconRight,
  text,
  onClick,
  disabled,
  type,
  title,
  style,
}) => {
  const buttonEl = useRef<HTMLButtonElement>(null);

  const handleOnClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    if (buttonEl.current) {
      buttonEl.current.blur();
    }
    if (onClick) {
      onClick();
    }
  };

  return (
    <UiButton
      id={htmlId}
      innerRef={buttonEl}
      className={className}
      onClick={handleOnClick}
      color="nothing"
      disabled={disabled}
      type={type}
      active={false}
      title={title}
      style={style}
    >
      <div className="d-flex align-items-center justify-content-left">
        {icon && <FontAwesomeIcon icon={icon} />}
        <span>{text}</span>
        {iconRight && <FontAwesomeIcon icon={iconRight} />}
      </div>
    </UiButton>
  );
};

export default LastValueButton;
